<template>
  <div class="row">
    <div class="col-sm-6">
      <transition name="el-fade-in-linear">
        <product-data :product="product" v-if="product" @deleteProduct="deleteProduct" />
      </transition>
    </div>
    <div class="col-sm-6">
      <div style="margin-bottom: 1em;" class="d-flex justify-content-between items-stretch">
        <router-link :to="`/?product=${product ? product.id : ''}`" class="btn btn-warning btn-xs">
          <i class="fas fa-exchange-alt"></i><br>
          Lagerbewegung erfassen
        </router-link>
        <router-link
          :to="`/orders/create?product=${product ? product.id : ''}&supplier=${cheapestSupplier ? cheapestSupplier.supplier_id : ''}`"
          class="btn btn-warning btn-xs">
          <i class="fas fa-shopping-cart"></i><br>
          Produkt bestellen
        </router-link>
        <el-dropdown trigger="click" v-if="$store.state.customLabels === 'medspa'">
          <button type="submit" class="btn btn-warning">
            <i class="fas fa-money-check"></i><br> Label drucken<i class="el-icon-arrow-down el-icon--right"></i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/small`"
                target="_blank">
                38x11mm
              </a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/medium`"
                target="_blank">
                28x51mm
              </a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/large`"
                target="_blank">
                57x32mm
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <router-link v-if="$store.state.activatedLabels.length > 1" :to="`/labels?product=${product ? product.id : ''}`"
          class="btn btn-warning btn-xs">
          <i class="fas fa-tags"></i><br>
          Etiketten drucken
        </router-link>
        <div>
          <a :href="`${api}/products/${product ? product.id : ''}/custom_label/barcode?barcode_size=${barCodeSize ? barCodeSize : '38x11'}`"
            target="_blank" class="btn btn-warning btn-xs">
            <i class="fas fa-barcode"></i><br>
            Barcode drucken
          </a>
        </div>
        <router-link :to="`/products/${product ? product.id : ''}/warehouse_config`" class="btn btn-warning btn-xs">
          <i class="fas fa-warehouse"></i><br>
          Warnschwellen & Sollmengen konf.
        </router-link>
      </div>
      <card>
        <template slot="header">
          <h4 class="card-title">Lagerstand</h4>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <table class="table" v-if="productWarehouses.length">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th class="text-center">Menge</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="stockRotation in productWarehouses" :key="stockRotation.warehouse_id">
                    <td v-text="stockRotation.warehouse.short_name"></td>
                    <td class="text-right" v-text="stockRotation.quantity"></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="border-top: 4px double;">
                    <td colspan="2" class="text-right">{{ inStock }}</td>
                  </tr>
                </tfoot>
              </table>
              <p v-else>Keine Lagerbewegungen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Letzte Lagerbewegungen</h4>
            <div>
              <router-link :to="`/stock_rotations?product=${this.$route.params.id}`" class="logo-mini">
                <i class="fas fa-exchange-alt" aria-hidden="true"></i> Alle anzeigen
              </router-link>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <table class="table table-striped table-bordered" v-if="lastStockRotations.length">
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Produkt</th>
                    <th>Menge</th>
                    <th>Preis</th>
                    <th>Grund</th>
                    <th>User</th>
                    <th>Lager</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr is="StockRotationRow" v-for="lastStockRotation in lastStockRotations" :key="lastStockRotation.id"
                    :stock-rotation="lastStockRotation" :accumulated="false" :show-warehouse="false"
                    @deleteStockRotation="deleteStockRotation" />
                </tbody>
              </table>
              <p v-else>Keine Lagerbewegungen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Lieferanten</h4>
            <button type="submit" class="btn btn-fill btn-primary" @click="openAssignToSuppliersDialog">
              Zuweisen
            </button>
          </div>
        </template>
        <product-suppliers-table :suppliers="productSuppliers" :show-edit="true"
          @deleteProductSupplier="deleteProductSupplier" @editProductSupplier="openProductSupplierEditDialog" @bla="bla"
          :product="product" />
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Letzte Bestellungen</h4>
          </div>
        </template>
        <last-orders-table :latestOrders="latestOrders" />

      </card>
      <!-- <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Alternativen</h4>
          </div>
        </template>
        <transition name="el-fade-in-linear">
          <products-table v-if="product && product.alternatives.length"
            :products="product.alternatives"
            :onlyShowAction="true"
          />
          <p v-if="product && ! product.alternatives.length">Keine Alternativen vorhanden</p>
        </transition>
      </card> -->
    </div>
    <assign-to-supplier-dialog v-if="product" :show="showAssignToSuppliersDialog" :suppliers="suppliers"
      @assignToSupplier="assignToSupplier" @close="showAssignToSuppliersDialog = false" :val-errors="assignErrors"
      :init-price="product.standard_price || ''" :init-referenznummer="product.referenznummer || ''" />
    <product-supplier-edit-dialog v-if="productSupplierToEdit" :show="showProductSupplierEditDialog"
      :init-referenznummer="productSupplierToEdit.referenznummer || ''" :init-price="productSupplierToEdit.price || ''"
      @updateProductSupplier="updateProductSupplier"
      @close="showAssignToSuppliersDialog = false; productSupplierToEdit = null" />
  </div>
</template>

<script>
import ProductSuppliersTable from './product-suppliers-table'
import AssignToSupplierDialog from './assign-to-supplier-dialog'
import ProductSupplierEditDialog from './product-supplier-edit-dialog'
import ProductData from './product-data'
import LastOrdersTable from './last-orders-table'
import { groupNewestSuppliers } from 'src/util/helpers'
import api from 'src/api'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'

export default {
  components: {
    ProductSuppliersTable,
    AssignToSupplierDialog,
    ProductSupplierEditDialog,
    ProductData,
    // ProductsTable,
    StockRotationRow,
    LastOrdersTable,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      barCodeSize: process.env.VUE_APP_BARCODE_SIZE,
      api,
      product: null,
      productSuppliersFetched: [],
      productWarehouses: [],
      showAssignToSuppliersDialog: false,
      showProductSupplierEditDialog: false,
      productSupplierToEdit: null,
      assignErrors: [],
      suppliers: [],
      lastStockRotations: [],
      latestOrders: []
    }
  },
  methods: {
    openAssignToSuppliersDialog() {
      let loadSuppliers = Promise.resolve()
      if (!this.suppliers.length) {
        loadSuppliers = this.$http.get(`/suppliers`).then(({ data }) => {
          this.suppliers = data
        })
      }
      loadSuppliers.then(() => { this.showAssignToSuppliersDialog = true })
    },
    openProductSupplierEditDialog(productSupplier) {
      this.productSupplierToEdit = productSupplier
      this.showProductSupplierEditDialog = true
    },
    async assignToSupplier(payload) {
      await this.initCsrf()

      const url = `/products/${this.product.id}/suppliers/${payload.supplier_id}`
      this.$http.post(url, { price: payload.price, referenznummer: payload.referenznummer }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferanten zugewiesen.',
          type: 'success'
        })
        this.showAssignToSuppliersDialog = false
        this.productSuppliersFetched.unshift(data)
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    showProduct(product) {
      this.$router.push({ path: `/products/${product.id}` })
    },
    fetchData() {
      this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
        this.product = data
      })
      this.$http.get(`/products/${this.$route.params.id}/suppliers`).then(({ data }) => {
        this.productSuppliersFetched = data
      })
      this.$http.get(`/products/${this.$route.params.id}/warehouses`).then(({ data }) => {
        this.productWarehouses = data
      })
      this.$http.get(`/stock_rotations?product=${this.$route.params.id}&limit=5`).then(({ data }) => {
        this.lastStockRotations = data
      })
      this.$http.get(`/latest-orders/product/${this.$route.params.id}`).then(({ data }) => {
        console.log(data)
        this.latestOrders = data;
      })

    },
    async deleteProductSupplier(supplier) {
      if (confirm('Zuweisung zum Lieferanten wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/product_supplier/${supplier.id}`).then(({ data }) => {
          const index = this.productSuppliersFetched.findIndex(({ id }) => id === data.id)
          this.$http.get(`/products/${this.$route.params.id}/suppliers`).then(({ data }) => {
            this.productSuppliersFetched = data
            this.$notify({
              message: 'Produkt Lieferant erfolgreich gelöscht',
              type: 'success'
            })
          })
        })
      }
    },
    bla(blub) {
      this.productSuppliersFetched.unshift(blub)
    },
    async deleteStockRotation(stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.lastStockRotations.findIndex(({ id }) => data.id === id)
          this.lastStockRotations.splice(index, 1)
        })
      }
    },
    async deleteProduct() {
      if (confirm(`Produkt ${this.product.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/products/${this.product.id}`).then(({ data }) => {
          this.$notify({
            message: `Produkt ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          this.$router.push('/products')
        })
      }
    },
    async updateProductSupplier(payload) {
      await this.initCsrf()

      this.$http.put(`/product_supplier/${this.productSupplierToEdit.id}`, payload).then(({ data }) => {
        this.productSupplierToEdit.referenznummer = data.referenznummer
        this.productSupplierToEdit.price = data.price
        this.showProductSupplierEditDialog = false
        this.productSupplierToEdit = null
      })
    }
  },
  computed: {
    inStock() {
      return this.productWarehouses.reduce((sum, stockRotation) => sum + +stockRotation.quantity, 0)
    },
    productSuppliers() {
      return groupNewestSuppliers(this.productSuppliersFetched)
    },
    cheapestSupplier() {
      return this.productSuppliersFetched.length ? this.productSuppliersFetched[0] : ''
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  }
}
</script>
